import {
  HueBar,
  Pointer,
  LightnessBar,
  SaturationBar,
  PickerContainer,
  ColorPickerContainer
} from './ColorPicker.styles';

import { hexToHsl, hslToHex } from '@/utils/common';
import { type TouchEvent, useState, useEffect } from 'react';

type ColorPickerProps = {
  setColor: (value: string) => void;
  update?: boolean;
  popup?: boolean;
  color: string;
};

export const ColorPicker = ({
  setColor,
  update,
  color,
  popup
}: ColorPickerProps) => {
  const [hsl, setHsl] = useState(hexToHsl(color));

  const updateHue = (event: TouchEvent) => {
    event.stopPropagation();

    let x = Math.max(event.touches[0].clientX - 40, 0);
    x /= (event.target as HTMLDivElement).clientWidth;

    const h = Math.min(x * 360, 360);
    const _hsl = { h, s: hsl.s, l: hsl.l };

    setHsl(_hsl);
    setColor(hslToHex(_hsl));
  };

  const updateSaturation = (event: TouchEvent) => {
    event.stopPropagation();

    let x = Math.max(event.touches[0].clientX - 40, 0);
    x /= (event.target as HTMLDivElement).clientWidth;

    const s = Math.min(x * 100, 100);
    const _hsl = { h: hsl.h, s, l: hsl.l };

    setHsl(_hsl);
    setColor(hslToHex(_hsl));
  };

  const updateLightness = (event: TouchEvent) => {
    event.stopPropagation();

    let x = Math.max(event.touches[0].clientX - 40, 0);
    x /= (event.target as HTMLDivElement).clientWidth;

    const l = Math.min(x * 100, 100);
    const _hsl = { h: hsl.h, s: hsl.s, l };

    setHsl(_hsl);
    setColor(hslToHex(_hsl));
  };

  useEffect(() => {
    update && setHsl(hexToHsl(color));
  }, [update]);

  useEffect(() => {
    setHsl(hexToHsl(color));
  }, []);

  return (
    <ColorPickerContainer popup={popup}>
      <label>Kies zelf de kleur</label>

      <PickerContainer>
        <HueBar onTouchStart={updateHue} onTouchMove={updateHue}>
          <Pointer left={hsl.h / 360} />
        </HueBar>

        <SaturationBar
          onTouchStart={updateSaturation}
          onTouchMove={updateSaturation}
          hsl={hsl}
        >
          <Pointer left={hsl.s / 100} />
        </SaturationBar>

        <LightnessBar
          onTouchStart={updateLightness}
          onTouchMove={updateLightness}
          hsl={hsl}
        >
          <Pointer left={hsl.l / 100} />
        </LightnessBar>
      </PickerContainer>
    </ColorPickerContainer>
  );
};
